 export const SheetSizesDictionary = {
  20: '2x10',
  24: '2x12',
  32: '4x8',
  48: '4x12'
 } ;


